<template>
  <div class="full-screen-box" ref="fullRef">
     <template v-if="isImage">
        <img 
            class="resources" 
            :src="url" 
            oncontextmenu="return false;"
        />
    </template>
    <template v-else >
        <video 
            v-if="!previewError"
            class="resources" 
            controls 
            controlslist="nodownload noremoteplayback noplaybackrate nofullscreen" 
            disablepictureinpicture="true" 
            disableremoteplayback="true" 
            :src="url" 
            oncontextmenu="return false;" 
            ref="videoRef"
        />
    </template>
  </div>
</template>

<script>
export default {
    props: [ 'url', 'isImage' ],
    mounted() {
       
    },
    methods: {
       
    }
}
</script>

<style lang="scss" scoped>
.full-screen-box {
    height: calc(100vh - 120px);
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    .resources {
        max-width: 100%;
        max-height: 100%;
        // min-width: 50%;
        // min-height: 50%;
        // height: 100%;
    }
}
</style>